import { css } from '@emotion/css';
import { Dimensions4 } from '@efexteam/design-tokens';

const title = css({
  textAlign: 'center',
});

const image = css({
  width: '100px',
  height: '100px',
  margin: '0 auto',
  marginBottom: Dimensions4,
});

const AddMemberConfirmationStyles = {
  title,
  image,
};

export default AddMemberConfirmationStyles;
